import '../stylesheets/App.css';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { apiCall } from '../helpers/apiCallConfiguration';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Popup from './popups/Popup';

library.add(faMagnifyingGlass);

function HistorialCliente() {

    const { idCliente } = useParams();

    let [clientes, setClientes] = useState([]);
    let [selectedCliente, setSelectedCliente] = useState('');
    let [historial, setHistorial] = useState(null);
    let [loading, setLoading] = useState(false);
    let [action, setAction] = useState('');
    let [element, setElement] = useState(null);

    const fetchHistorial = (id) => {
        setLoading(true);
        setHistorial(null);
        apiCall(
            process.env.REACT_APP_API_BASE_URL + '/clientes/historial/' + id,
            (data) => {
                setHistorial(data.data);
                setLoading(false);
            }
        );
    };

    useEffect(() => {
        apiCall(process.env.REACT_APP_API_BASE_URL + '/clientes/list/', (data) => {
            setClientes(data.data);
        });
        if (idCliente) {
            setSelectedCliente(idCliente.toString());
            fetchHistorial(idCliente);
        }
    }, []);

    const estadoLabel = (estado) => {
        switch (parseInt(estado)) {
            case 1: return 'Activa';
            case 2: return 'Refinanciada';
            case 3: return 'Saldada';
            default: return estado;
        }
    };

    const deudaVentas = historial
        ? (historial.ventas || []).filter(v => v.estado === 1).reduce((sum, v) => sum + Math.max(0, parseFloat(v.saldo || 0)), 0)
        : 0;
    const deudaRefinanciamientos = historial
        ? (historial.refinanciamientos || []).reduce((sum, r) => sum + Math.max(0, parseFloat(r.saldo || 0)), 0)
        : 0;
    const totalDeuda = deudaVentas + deudaRefinanciamientos;

    return (
        <div className="container my-5">
            <h1 className="general-subtitle text-center my-4">Historial de Cliente</h1>
            <div className="col-12 m-auto border rounded border-dark-blue p-4">

                <div className="d-flex gap-3 align-items-center mb-4 flex-wrap">
                    <select
                        className="form-select"
                        value={selectedCliente}
                        onChange={(e) => setSelectedCliente(e.target.value)}
                    >
                        <option value="">Seleccionar cliente</option>
                        {clientes.map((c, i) => (
                            <option key={i} value={c.idCliente}>{c.nombre}</option>
                        ))}
                    </select>
                    <button
                        className="btn rounded-pill btn-dark"
                        onClick={() => selectedCliente && fetchHistorial(selectedCliente)}
                        disabled={!selectedCliente || loading}
                    >
                        {loading ? 'Cargando...' : 'Obtener historial'}
                    </button>
                </div>

                {historial && (
                    <>
                        <div className="border rounded p-3 mb-4 d-flex flex-wrap gap-4 align-items-center">
                            <div><strong>Cliente:</strong> {historial.nombre}</div>
                            <div><strong>Teléfono:</strong> {historial.telefono}</div>
                            <div><strong>Nivel:</strong> {historial.nivel?.descripcion}</div>
                            <div className="ms-auto fs-5">
                                <strong>Deuda total: </strong>
                                <span className={totalDeuda > 0 ? 'text-danger' : 'text-success'}>
                                    $ {totalDeuda.toLocaleString(undefined, { maximumFractionDigits: 2 })}
                                </span>
                            </div>
                        </div>

                        <h5 className="mt-3">Ventas ({historial.ventas?.length || 0})</h5>
                        {historial.ventas?.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Fecha</th>
                                            <th>Producto</th>
                                            <th>Plan</th>
                                            <th>Total</th>
                                            <th>Pagado</th>
                                            <th>Saldo</th>
                                            <th>Estado</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {historial.ventas.map((v, i) => (
                                            <tr key={i} className={v.estado === 3 ? 'text-muted' : ''}>
                                                <td>{v.idVenta}</td>
                                                <td>{new Date(v.fecha + 'T00:00:00').toLocaleDateString()}</td>
                                                <td>{v.detalles?.map(d => d.producto?.descripcion).join(', ')}</td>
                                                <td>{v.plan?.descripcion}</td>
                                                <td>$ {v.precioFinal?.toLocaleString()}</td>
                                                <td>$ {v.montoPagado?.toLocaleString()}</td>
                                                <td>$ {Math.max(0, parseFloat(v.saldo || 0)).toLocaleString(undefined, { maximumFractionDigits: 2 })}</td>
                                                <td>{estadoLabel(v.estado)}</td>
                                                <td>
                                                    <FontAwesomeIcon
                                                        icon={faMagnifyingGlass}
                                                        className="pointer"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#exampleModal"
                                                        onClick={() => { setAction('Ver detalle'); setElement(v); }}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : <p className="text-muted">Sin ventas registradas.</p>}

                        <h5 className="mt-4">Refinanciamientos ({historial.refinanciamientos?.length || 0})</h5>
                        {historial.refinanciamientos?.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Fecha</th>
                                            <th>Descripción</th>
                                            <th>Plan</th>
                                            <th>Total a pagar</th>
                                            <th>Pagado</th>
                                            <th>Saldo</th>
                                            <th>Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {historial.refinanciamientos.map((r, i) => (
                                            <tr key={i} className={r.estado === 3 ? 'text-muted' : ''}>
                                                <td>{r.idRefinanciamiento}</td>
                                                <td>{new Date(r.fecha + 'T00:00:00').toLocaleDateString()}</td>
                                                <td>{r.descripcion}</td>
                                                <td>{r.plan?.descripcion}</td>
                                                <td>$ {r.totalAPagar?.toLocaleString()}</td>
                                                <td>$ {r.montoPagado?.toLocaleString()}</td>
                                                <td>$ {Math.max(0, parseFloat(r.saldo || 0)).toLocaleString(undefined, { maximumFractionDigits: 2 })}</td>
                                                <td>{estadoLabel(r.estado)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : <p className="text-muted">Sin refinanciamientos registrados.</p>}
                    </>
                )}
            </div>
            <Popup object="ventas" action={action} element={element} setActualizar={() => fetchHistorial(selectedCliente)} />
        </div>
    );
}

export default HistorialCliente;
